import "./LinkedinAddAccountBody.scss"

import { Checkbox, FooterVariant, SvgIcon } from "@skylead/component-library"
import moment from "moment-timezone"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import * as actions from "../../../redux/actions"
// eslint-disable-next-line import/no-cycle
import {
  addLinkedinAccountModal,
  disconnectLinkedinAccount,
  handleAddLinkedinAccount,
  // integrationsModal,
  openEmailProviderConnect,
} from "../../../utils/account-utils"
import { useGlobalTranslation, useTooltip } from "../../../utils/hook"
import { hasPermission, PERMISSIONS } from "../../../utils/team-management/team-management-utils"
import { validateSeat } from "../../../utils/validation/validation-utils"
import Button, { ButtonVariant } from "../../atoms/Button"
import LangText from "../../atoms/LangText"
import ModalWrapper from "../../atoms/ModalWrapper"
import InputGroup from "../InputGroup"
import LinkedinSubscription from "../LinkedinSubscription"

const LinkedinAddAccountBody = ({ modal, person, proxyCountries }) => {
  const dispatch = useDispatch()
  const { tt } = useGlobalTranslation()
  const [tooltip, setTooltip, closeTooltip] = useTooltip(10, 0)

  const [passwordType, setPasswordType] = useState("password")

  const [formData, { profile, seat }, formErrors] = useSelector(state => [
    state.forms.formData,
    state.user,
    state.forms.formErrors,
  ])
  const { showDefaultProxies, showSeatInfo, currentSeat, selectedTimezone } = formData

  const [confirmAccessToEmail, setConfirmAccessToEmail] = useState(false)

  useEffect(() => {
    if (modal === "LINKEDIN") {
      dispatch(actions.updateFormField("person", person))
      dispatch(actions.setActiveAccountID(person.id))
    }
    dispatch(actions.updateFormFields({ startUTCTime: "09:00", endUTCTime: "17:00" }))
  }, [modal, person])

  const linkedinSubscriptionId = formData["linkedin-subscription"] || 1

  const onLinkedinSubscriptionChange = (subscriptionId = linkedinSubscriptionId) => {
    dispatch(actions.updateFormField("linkedin-subscription", subscriptionId))
  }

  const validateField = async () => {
    const { seatName } = formData
    const allErrors = await validateSeat({ seatName })
    dispatch(actions.setFormErrors(allErrors))
    return !allErrors
  }

  const connectEmailProvider = async (event, proxies = proxyCountries) => {
    const userID = profile.id
    const ifExistSeat = Object.keys(seat).length !== 0

    if (ifExistSeat) {
      const showIntegrationModal = true
      openEmailProviderConnect(tt, event, userID, seat, proxies, showIntegrationModal)
    }
  }

  const connectLinkedinAccount = async (proxies = proxyCountries) => {
    const ifExistSeat = Object.keys(seat).length !== 0

    if (ifExistSeat) {
      const showIntegrationModal = true
      addLinkedinAccountModal(tt, seat, proxies, showIntegrationModal, showSeatInfo)
    }
  }

  const createSeat = async () => {
    const isValidated = await validateField()
    if (isValidated) {
      dispatch(actions.setModalLoader(true))
      const { seatName, startUTCTime, endUTCTime } = formData

      const newStartUTCTime = moment
        .tz(startUTCTime, "HH:mm", selectedTimezone.name)
        .utc()
        .format("HH:mm")

      const newEndUTCTime = moment
        .tz(endUTCTime, "HH:mm", selectedTimezone.name)
        .utc()
        .format("HH:mm")

      const createdAccount = await dispatch(
        actions.addAccount(seatName, newStartUTCTime, newEndUTCTime, selectedTimezone.name),
      )
      if (createdAccount) {
        dispatch(actions.getAvailableSeatsForUser())
        dispatch(actions.getAvailableSeatsForTeam())
        dispatch(actions.closeModal())
        // TODO MJ@Any: Check if we will use this modal in horizon its not in horizon for now. Don't delete this if we we didn't check this.
        // integrationsModal(createdAccount, proxyCountries)
      }
      dispatch(actions.setModalLoader(false))
    }
  }

  const closeSeatInfo = () => {
    dispatch(actions.closeModal())
    actions.clearForm()
  }

  const onLinkedinAccountConnect = async (user = person, proxies = proxyCountries) => {
    await handleAddLinkedinAccount(tt, user, proxies)
  }

  // const handleBack = () => {
  //   dispatch(actions.hideInfoModal())
  //   addLinkedinAccountModal(person, proxyCountries)
  // }

  const connectedLinkedinAccount = currentSeat ? currentSeat.email : false
  const showIntegrationsModal = true
  const canConnectLinkedin =
    person && hasPermission(PERMISSIONS.LINKEDIN_INTEGRATIONS_EDIT, person.id)
  const canConnectEmail = person && hasPermission(PERMISSIONS.EMAIL_SETTINGS_EDIT, person.id)

  switch (modal) {
    case "INTEGRATIONS":
      return (
        <>
          {tooltip}
          <div className="seat-info-modal-wrapper">
            <p>
              <LangText langKey="linked.add.account.body.integration.msg.1" />{" "}
              <span className="seat-info-italic">
                <LangText langKey="linked.add.account.body.integration.msg.2" />
              </span>
            </p>
            <br />
            <div className="d-flex">
              <div className="connect-wrapper" aria-label="Connect linkedin button">
                <span className="optional">
                  <LangText langKey="optional" />
                </span>
                <SvgIcon icon="linkedin-seat-info-modal" className="seat-info-modal-img" />
                {connectedLinkedinAccount ? (
                  <div
                    onPointerEnter={e => {
                      if (!canConnectLinkedin) {
                        setTooltip({
                          event: e,
                          text: (
                            <p>
                              <LangText langKey="linked.add.account.body.connected-linkedin.msg.1" />{" "}
                              <i>
                                {" "}
                                <LangText langKey="linked.add.account.body.connected-linkedin.msg.2" />
                              </i>{" "}
                              <LangText langKey="linked.add.account.body.connected-linkedin.msg.3" />
                            </p>
                          ),
                          topPos: 88,
                          leftPos: -35,
                          customSytle: { maxWidth: 230 },
                          caretBottom: true,
                        })
                      }
                    }}
                    onPointerLeave={() => {
                      if (!canConnectLinkedin) {
                        closeTooltip()
                      }
                    }}
                  >
                    <Button
                      variant={ButtonVariant.DANGER}
                      icon="disconnect-email"
                      disabled={!canConnectLinkedin}
                      onClick={() =>
                        disconnectLinkedinAccount(tt, proxyCountries, showIntegrationsModal)
                      }
                    >
                      <LangText langKey="disconnect" />
                    </Button>
                  </div>
                ) : (
                  <div
                    onPointerEnter={e => {
                      if (!canConnectLinkedin) {
                        setTooltip({
                          event: e,
                          text: (
                            <p>
                              <LangText langKey="linked.add.account.body.connect-linkedin.msg.1" />{" "}
                              <i>
                                <LangText langKey="linked.add.account.body.connect-linkedin.msg.2" />
                              </i>{" "}
                              <LangText langKey="linked.add.account.body.connect-linkedin.msg.3" />
                            </p>
                          ),
                          topPos: 88,
                          leftPos: -35,
                          customSytle: { maxWidth: 230 },
                          borderBottom: true,
                        })
                      }
                    }}
                    onPointerLeave={() => {
                      if (!canConnectLinkedin) {
                        closeTooltip()
                      }
                    }}
                  >
                    <Button
                      variant={ButtonVariant.SECONDARY}
                      icon="connect-email"
                      disabled={!canConnectLinkedin}
                      onClick={() => connectLinkedinAccount(proxyCountries)}
                    >
                      <LangText langKey="connect" />
                    </Button>
                  </div>
                )}
              </div>
              <div className="connect-wrapper" aria-label="Connect email button">
                <span className="optional">
                  <LangText langKey="optional" />
                </span>
                <SvgIcon icon="email-seat-info-modal" className="seat-info-modal-img" />
                <div
                  onPointerEnter={e => {
                    if (!canConnectEmail) {
                      setTooltip(
                        e,
                        <p>
                          <LangText langKey="linked.add.account.body.connect-email.msg.1" />{" "}
                          <i>
                            <LangText langKey="linked.add.account.body.connect-email.msg.2" />
                          </i>{" "}
                          <LangText langKey="linked.add.account.body.connect-email.msg.3" />
                        </p>,
                        88,
                        -45,
                        undefined,
                        { maxWidth: 210 },
                        true,
                        true,
                      )
                    }
                  }}
                  onPointerLeave={() => {
                    if (!canConnectEmail) {
                      closeTooltip()
                    }
                  }}
                >
                  <Button
                    variant={ButtonVariant.SECONDARY}
                    icon="connect-email"
                    disabled={!canConnectEmail}
                    onClick={event => connectEmailProvider(event, proxyCountries)}
                  >
                    <LangText langKey="connect" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )
    case "LINKEDIN":
      return (
        <ModalWrapper
          footerVariant={FooterVariant.PROGRESS}
          primaryBtn={{
            label: tt("submit"),
            onClick: () => onLinkedinAccountConnect(person, proxyCountries),
            disabled: !confirmAccessToEmail,
          }}
          secondaryBtn={{ label: tt("previous") }}
          tertiaryBtn={{ label: tt("cancel") }}
          showPreviuos
        >
          <div className="add-linkedin-account-wrapper">
            <LinkedinSubscription
              onChange={onLinkedinSubscriptionChange}
              explanation
              isConnectLinkedin
            />

            <div className="add-linkedin-account-details">
              <InputGroup
                type="email"
                field="emailAddress"
                label={tt("linkedin-email-address")}
                placeholder={tt("linkedin-email-address")}
                inputGroupClassName="input-on-surface"
              />

              <InputGroup
                field="password"
                label={tt("linkedin-password")}
                placeholder={tt("enter-linkedin-password")}
                type={passwordType}
                passwordType={passwordType}
                setPasswordType={setPasswordType}
              />
            </div>

            <div className="add-linedin-account-checkbox">
              <Checkbox
                onClick={() => setConfirmAccessToEmail(!confirmAccessToEmail)}
                checked={confirmAccessToEmail}
              />
              <p className="large add-linedin-account-checkbox-description">
                <LangText langKey="linked.add.account.body.confirm-access.msg" />
              </p>
            </div>
          </div>
        </ModalWrapper>
      )
    case "PROXY":
      return (
        <div className="mb-4">
          {showDefaultProxies ? (
            <div>
              <InputGroup
                field="selectedProxy"
                type="select"
                inputGroupClassName="input-on-surface"
                label={tt("linked.add.account.body.country-of-access.label")}
                message={tt("linked.add.account.body.country-of-access.msg")}
              >
                {proxyCountries?.map(option => (
                  <option key={option.countryCode} value={option.countryCode}>
                    {option.countryName}
                  </option>
                ))}
              </InputGroup>
            </div>
          ) : (
            <div className="custom-proxy-inputs">
              <InputGroup
                field="proxyHostWithPort"
                label={tt("host-with-port")}
                placeholder={tt("host-with-port.placeholder")}
              />
              <InputGroup field="proxyUsername" label={tt("username")} />
              <InputGroup
                field="proxyPassword"
                label={tt("password")}
                type={passwordType}
                passwordType={passwordType}
                setPasswordType={setPasswordType}
              />
            </div>
          )}
        </div>
      )
    case "SEAT_INFO":
      return (
        <ModalWrapper
          footerVariant={FooterVariant.TRANSACTIONAL}
          primaryBtn={{
            label: tt("add"),
            onClick: createSeat,
            disabled: !selectedTimezone?.name,
          }}
          secondaryBtn={{
            label: tt("cancel"),
            onClick: () => {
              closeSeatInfo()
              dispatch(actions.closeModal())
            },
          }}
          showPrevious
        >
          <div className="seat-info-modal-wrapper">
            <InputGroup
              inputGroupClassName="input-on-surface"
              field="seatName"
              label={tt("seat-name")}
              placeholder="e.g. Luca Johnsson or Tech Solutions"
              message={formErrors.seatName ? formErrors.seatName : ""}
            />
            <br />
            <div className="seat-time-picker">
              {/* Refactor this, we have on 3 places timezone all in different components :( */}
              <InputGroup
                field="selectedTimezone"
                type="timezone"
                label={tt("time-zone")}
                inputGroupClassName="input-on-surface"
                inputClassName="timezone-picker timezone-picker-background timezone-picker-open-up limit-timezone-picker-height"
                inputProps={{
                  placeholder: tt("select-timezone-placeholder"),
                  name: "timezone",
                }}
              />
            </div>
            <br />
          </div>
        </ModalWrapper>
      )
    default:
      break
  }
  return null
}

// LinkedinAddAccountBody.propTypes = {
//   proxyCountries: PropTypes.instanceOf(Array).isRequired,
//   person: PropTypes.instanceOf(Object).isRequired,
//   modal: PropTypes.string.isRequired,
// }

export default LinkedinAddAccountBody
